const UPDATE_USER = (state, payload) => {
  state.user[payload.field] = payload.value;
};

export default UPDATE_USER;
